import React from 'react';
import { Tabs, Tab } from '@nextui-org/react';
import { ExpandAllButton } from './ExpandAllButton';
import { isCompactApplicationType } from '../utils/constants';

export interface RendererTabsProps {
    activeTab: string;
    onTabChange: (key: string) => void;
    isExpanded: boolean;
    onExpandAll: () => void;
    knowledgeComponent?: React.ReactNode;
    overviewContent: React.ReactNode;
    className?: string;
    /** When false, only Overview is shown (no Sources tab). Defaults to true. */
    showSourcesTab?: boolean;
}

export const RendererTabs: React.FC<RendererTabsProps> = ({
    activeTab,
    onTabChange,
    isExpanded,
    onExpandAll,
    knowledgeComponent,
    overviewContent,
    className = '',
    showSourcesTab = true,
}) => {
    const tabListPaddingRight =
        !isCompactApplicationType() && activeTab === 'overview' ? 'pr-32' : 'pr-4';

    if (!showSourcesTab) {
        return (
            <div className={`flex-1 overflow-y-auto p-1 pt-0 mb-4 relative ${className}`}>
                {overviewContent}
                <div className="absolute top-1 right-4 flex items-center" style={{ height: '32px' }}>
                    <ExpandAllButton isExpanded={isExpanded} onToggle={onExpandAll} />
                </div>
            </div>
        );
    }

    return (
        <div className={`flex-1 overflow-y-auto p-1 pt-0 mb-4 relative ${className}`}>
            <Tabs
                selectedKey={activeTab}
                onSelectionChange={(key) => onTabChange(key as string)}
                aria-label="Content tabs"
                variant="underlined"
                classNames={{
                    tabList: `gap-3 relative rounded-none pl-4 ${tabListPaddingRight}`,
                    cursor: "w-full bg-primary",
                    tab: "max-w-fit px-4 h-10",
                    tabContent: "group-data-[selected=true]:text-primary"
                }}
            >
                <Tab key="overview" title="Overview" className='font-semibold'>
                    <div>
                        {overviewContent}
                    </div>
                </Tab>
                <Tab key="sources" title="Sources" className='font-semibold'>
                    <div className="w-full">
                        {knowledgeComponent}
                    </div>
                </Tab>
            </Tabs>
            {activeTab === 'overview' ? (
                <div className="absolute top-1 right-4 flex items-center" style={{ height: '32px' }}>
                    <ExpandAllButton isExpanded={isExpanded} onToggle={onExpandAll} />
                </div>
            ) : null}
        </div>
    );
};
